// Status tones for the candidate journey, on the design system's five fixed
// tones. One place, so the list and the candidate record agree.

export function stageTone(stage = '') {
  if (stage === 'Joined' || stage === 'Offered') return 'success';
  if (stage === 'In F2F interviews' || stage === 'In AI assessment') return 'warning';
  if (stage === 'Shortlisted' || stage === 'CV screened' || stage === 'Fee paid') return 'info';
  return 'neutral';
}

// Match score colour: the status text tones, never the action teal.
export function matchColor(score) {
  if (score >= 80) return 'var(--status-success-text)';
  if (score >= 60) return 'var(--status-warning-text)';
  return 'var(--status-danger-text)';
}
